// SheetDB-ark för alla Halloweek-bokningar.
// Varje dag har egna kolumner med prefix, t.ex. "Brunch Förnamn".
const EVENT_SHEETDB_URL = 'https://sheetdb.io/api/v1/8tta836h6djrb'

interface EventSheetConfig {
  prefix: string
  code: string
  /** Sheet column (without prefix) that stores the booking choice */
  choiceColumn?: string
  hasPartySize?: boolean
}

const EVENT_SHEET: Record<string, EventSheetConfig> = {
  'halloween-run-club': { prefix: 'Run', code: 'RUN', choiceColumn: 'Deltar i' },
  'halloween-hidden-reality': {
    prefix: 'Hidden',
    code: 'HR',
    choiceColumn: 'Spelform',
    hasPartySize: true,
  },
  'halloween-barnens-dag': { prefix: 'Barn', code: 'BARN' },
  'halloween-monsterdisko': { prefix: 'Disko', code: 'DISKO' },
  'halloween-hostbrunch': {
    prefix: 'Brunch',
    code: 'BRUNCH',
    choiceColumn: 'Sittning',
    hasPartySize: true,
  },
}

export function createBookingNumber(eventId: string): string {
  const code = EVENT_SHEET[eventId]?.code ?? 'EV'
  return `HW-${code}-${Math.floor(1000 + Math.random() * 9000)}`
}

interface EventBooking {
  eventId: string
  bookingNumber: string
  date: string
  time: string
  choice: string | null
  partySize: number | null
  childFirstName?: string
  childLastName?: string
  firstName: string
  lastName: string
  email: string
  phone: string
}

export async function saveEventBooking(b: EventBooking): Promise<boolean> {
  const cfg = EVENT_SHEET[b.eventId]
  if (!cfg) return false
  const p = cfg.prefix
  const row: Record<string, string> = {
    [`${p} Bokningsnummer`]: b.bookingNumber,
    [`${p} Skickad`]: new Date().toLocaleString('sv-SE', {
      timeZone: 'Europe/Stockholm',
    }),
    [`${p} Datum`]: b.date,
    [`${p} Tid`]: b.time,
    [`${p} Förnamn`]: b.firstName,
    [`${p} Efternamn`]: b.lastName,
    [`${p} E-post`]: b.email,
    [`${p} Telefon`]: b.phone,
  }
  if (b.childFirstName !== undefined) {
    row[`${p} Barn förnamn`] = b.childFirstName
    row[`${p} Barn efternamn`] = b.childLastName ?? ''
  }
  if (cfg.choiceColumn) row[`${p} ${cfg.choiceColumn}`] = b.choice ?? ''
  if (cfg.hasPartySize)
    row[`${p} Antal personer`] = b.partySize ? String(b.partySize) : ''

  try {
    const res = await fetch(EVENT_SHEETDB_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ data: [row] }),
    })
    return res.ok
  } catch {
    return false
  }
}
